import PrimaryButton from './PrimaryButton';

export default function ContactButton({ buttonText, emailAddress }) {
  const handleClick = () => {
    window.location.href = `mailto:${emailAddress}`;
  };

  return <PrimaryButton buttonText={buttonText} onClick={handleClick} />;
}
